module.exports = __webpack_public_path__ + "img/first-login-msg-icon.5c82a0b8.svg";